// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"14c7c176","453":"f8768ebe"}[chunkId] + ".chunk.js";
};